import React, { useState } from "react";
import { ContactsTable } from "@/components/Admin/ContactsTable";
import { StatusFilter } from "@/components/Admin/StatusFilter";

export const AdminContactsView = ({ gate, api }) => {
  const [filter, setFilter] = useState("todos");
  const [savingId, setSavingId] = useState(null);
  const [error, setError] = useState("");
  const contacts = gate.data;
  const visible = filter === "todos" ? contacts : contacts.filter((c) => c.status === filter);

  const onStatusChange = async (id, status) => {
    setSavingId(id);
    setError("");
    try {
      const { data } = await gate.authRequest({ method: "patch", url: `${api}/contact/${id}/status`, data: { status } });
      gate.setData((list) => list.map((c) => (c.id === id ? data : c)));
    } catch (err) {
      if (err.response?.status === 401) return gate.logout();
      setError("Não foi possível atualizar o status. Tente novamente.");
    } finally {
      setSavingId(null);
    }
  };

  return (
    <>
      <div className="admin-title-row">
        <div>
          <span className="eyebrow">ADMIN</span>
          <h1 className="h-3">Contatos recebidos</h1>
        </div>
        <span className="mono-sm admin-count" data-testid="admin-contacts-count">
          {contacts.length} {contacts.length === 1 ? "contato" : "contatos"}
        </span>
      </div>
      <StatusFilter contacts={contacts} value={filter} onChange={setFilter} />
      {error && (
        <p className="form-error" data-testid="admin-status-error">
          {error}
        </p>
      )}
      <ContactsTable contacts={visible} onStatusChange={onStatusChange} savingId={savingId} />
    </>
  );
};
